import styled from '@emotion/styled'

export const StyledKeywordContainer = styled.div`
  margin-bottom: 16px;
  .mantine-Carousel-root {
    cursor: grab;
  }
  .mantine-Carousel-control {
    &[data-inactive] {
      opacity: 0;
      cursor: default;
    }
    background-color: #ffffff;
    opacity: 1;
  }
  .mantine-Carousel-viewport {
    width: calc(100% - 36px);
  }
  .mantine-Carousel-controls {
  }
`
